export default __webpack_public_path__ + "static/media/whatsapp.66915591.svg";